import LinearProgress from '@material-ui/core/LinearProgress';
import React from 'react';

interface ProgressStateProps {
    value: number;
    total: number;
}

const ProgressState: React.FC<ProgressStateProps> = (props) => {
    const { value, total } = props;

    return (
        <div className="section-spacer mid">
            <div className="progress-state">
                <span className="small-title">{value}</span>
                <span className="small-title small-text">{` / ${total}`}</span>
            </div>
            <LinearProgress variant="determinate" value={(value / total) * 100} />
        </div>
    );
};

export default ProgressState;
